<template>
  <div class="container-fluid mt-4">
    <b-row class="mb-3 pb-1 border-bottom">
      <b-col>
        <span :class="`size-${ButtonSize}`">Seçenek Düzenle</span>
      </b-col>

      <b-col cols="auto" class="text-right">
        <b-btn
          class="mr-3"
          type="button"
          variant="danger"
          :to="`/Products/${ProductID}`"
          :size="ButtonSize"
        >
          <i class="material-icons mifix">arrow_back</i>
          <span class="ml-1">Geri</span>
        </b-btn>

        <b-btn type="button" variant="info" :size="ButtonSize" @click.prevent="Refresh()">
          <i class="material-icons mifix">refresh</i>
          <span class="ml-1">Yenile</span>
        </b-btn>
      </b-col>
    </b-row>

    <b-alert show variant="danger" v-if="Object.keys(Product).length === 0">Hata!</b-alert>

    <template v-else>
      <b-alert show variant="danger" v-if="ExtraTypesGUI.length === 0">Hata!</b-alert>

      <template v-else>
        <b-alert show variant="danger" v-if="Object.keys(Extra).length === 0">Hata!</b-alert>

        <template v-else>
          <b-alert show variant="info">Ait Olduğu Ürün: {{ Product.Name }}</b-alert>

          <form @submit.prevent="SaveExtra">
            <b-form-group class="formgroup" label="Seçenek Türü">
              <b-form-select v-model="Extra.TypeID" :options="ExtraTypesGUI"></b-form-select>
            </b-form-group>

            <b-form-group class="formgroup" label="Seçenek">
              <b-form-input type="text" v-model="Extra.Name"></b-form-input>
            </b-form-group>

            <b-form-group class="formgroup" label="Fiyat">
              <b-form-input type="number" step="0.01" min="0" v-model="Extra.Price"></b-form-input>
            </b-form-group>

            <div class="m-t-40 d-block border-top pt-3 pl-3">
              <b-btn type="submit" variant="success" size="lg">
                <i class="material-icons mifix">save</i>
                <span class="ml-1">Kaydet</span>
              </b-btn>
            </div>
          </form>
        </template>
      </template>
    </template>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Services from "../Service";

export default {
  data() {
    return {
      Extra: {},
      ExtraTypesGUI: [],
      Product: {}
    };
  },
  computed: {
    ...mapState(["StoreData", "ButtonSize"]),
    ProductID() {
      return this.$route.params.ProductID;
    },
    TypeID() {
      return this.$route.params.TypeID;
    },
    ExtraID() {
      return this.$route.params.ID;
    }
  },
  methods: {
    async Refresh() {
      if (this.StoreData.Products[this.ProductID]) {
        await this.$set(
          this,
          "Product",
          this.StoreData.Products[this.ProductID]
        );

        let _ExtraTypes = [];

        if (this.StoreData.Products[this.ProductID])
          if (this.StoreData.Products[this.ProductID].ExtraTypes)
            for (let i in this.StoreData.Products[this.ProductID].ExtraTypes) {
              const _ExtraType = this.StoreData.Products[this.ProductID]
                .ExtraTypes[i];

              _ExtraTypes.push({
                value: _ExtraType.ID,
                text: _ExtraType.Name
              });
            }

        await this.$set(this, "ExtraTypesGUI", _ExtraTypes);

        if (this.StoreData.Products[this.ProductID].ExtraTypes[this.TypeID])
          if (
            this.StoreData.Products[this.ProductID].ExtraTypes[this.TypeID]
              .Extras[this.ExtraID]
          ) {
            await this.$set(
              this,
              "Extra",
              Object.assign(
                {},
                this.StoreData.Products[this.ProductID].ExtraTypes[this.TypeID]
                  .Extras[this.ExtraID]
              )
            );
          }
      }
    },
    async SaveExtra() {
      await this.$store.dispatch("AddLoading", "SaveExtra");

      await Services.Nozich.Send(
        "SaveExtra",
        {
          Extra: this.Extra
        },
        async Data => {
          await this.$store.dispatch("RemoveLoading", "SaveExtra");

          if (Data.Status === "Success") {
            await this.$router.push(`/Products/${this.ProductID}`);
          }
        }
      );
    }
  },
  async mounted() {
    await this.Refresh();

    this.$store.subscribe(async () => {
      await this.$nextTick();
      await this.$forceUpdate();
      await this.Refresh();
    });
  }
};
</script>
